export const environment = {
    production: false,
    api_url: "https://flipeon-develop.jnmoura.com.br/api"
};